/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Pending_HintInputs */



/**
* | output |
* | --- |
* | "Add or correct the records below, then check again. We keep checking on our own, so you can also close this and come back later." |
*
* @param {Canvas_Domain_Pending_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_pending_hint = /** @type {((inputs?: Canvas_Domain_Pending_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Pending_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ergänzen oder korrigieren Sie die Einträge unten und prüfen Sie erneut. Wir prüfen auch selbst weiter — Sie können dieses Fenster also schließen und später zurückkommen.")
	return /** @type {LocalizedString} */ ("Add or correct the records below, then check again. We keep checking on our own, so you can also close this and come back later.")
});